export const veridionPageIT = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | L’organizzazione di collaboratori IA",
    "description": "Il prossimo livello di produttività: l’Organisation as a Service. Un’organizzazione di collaboratori IA consegna lavoro verificato, pianificabile in cicli fissi, on-premises o nel vostro cloud."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Un creatore, infinite soluzioni.",
    "claim": "Il prossimo livello di produttività: l’Organisation as a Service.",
    "lead": "L’IA aziendale che dirige l’intera pAIoneer Labs GmbH: una forza lavoro di collaboratori IA che si integra in ogni processo della vostra azienda, porta il lavoro a termine da sola e impara con ogni compito. Le persone danno la direzione. Tutto il resto avviene da sé."
  },
  "vision": {
    "lines": [
      "Il software ha dato alle aziende strumenti.",
      "L’IA ha dato loro assistenti.",
      "Veridion dà loro un’organizzazione."
    ],
    "note": "Le informazioni si muovono in ore, l’esperienza va in pensione, le posizioni restano scoperte. Un ennesimo strumento non lo risolve; lo risolve una forza lavoro che non dovete assumere."
  },
  "grow": {
    "title": "Ciò che non sa fare, lo crea",
    "text": "Quando per un compito non esiste ancora una capacità o qualcosa non può essere risolto con i mezzi esistenti, Veridion sviluppa autonomamente nuovi sistemi di IA arbitrariamente complessi — l’IA sviluppa ulteriormente l’IA: progettati, costruiti, verificati e messi in esercizio. Solo il rilascio resta alla persona tramite l’[Intent-Driven Development](idd) (IDD).",
    "punch": "È esattamente questo: un creatore, infinite soluzioni."
  },
  "integrate": {
    "title": "Nel cuore dei vostri processi",
    "subtitle": "Nessun nuovo software, nessuna formazione, nessuna migrazione.",
    "cards": [
      {
        "title": "Nella chat aziendale",
        "text": "Si parla dove in azienda si scrive già: Webex, Microsoft Teams, Zoom, Slack. Basta un messaggio."
      },
      {
        "title": "Nei vostri strumenti",
        "text": "Project management, repository, archivi: si lavora nei sistemi che ci sono, non aggirandoli."
      },
      {
        "title": "Dall’offerta alla contabilità",
        "text": "Un processo dopo l’altro, al vostro ritmo. Quando le capacità scarseggiano, anche solo un singolo pacchetto di sviluppo o un progetto intero."
      }
    ]
  },
  "org": {
    "title": "Una forza lavoro, organizzata come un’azienda",
    "subtitle": "Non imponiamo alcuno schema rigido: per qualsiasi struttura aziendale progettiamo un organigramma individuale, assegniamo ruoli e responsabilità chiari e ci adattiamo con flessibilità. Ogni Business Unit è composta da collaboratori IA orchestrati da Veridion che lavorano in modo completamente automatizzato fino all’[IDD](idd) Human-in-the-Loop — e quando qualcosa non è ancora possibile, Veridion sviluppa da sé una nuova IA.",
    "execKicker": "Livello di coordinamento — completamente automatizzato fino all’IDD Human-in-the-Loop",
    "execTitle": "Organigramma su misura, ruoli chiari e un’IA che sviluppa ulteriormente l’IA.",
    "execText": "Sotto i decisori umani, il livello di coordinamento e le Business Unit di collaboratori IA operano in modo completamente automatizzato: scompongono gli obiettivi, distribuiscono il lavoro su ruoli e responsabilità chiaramente definiti, risolvono i problemi in autonomia e richiedono approvazioni mirate alle persone. L’umano nel loop governa tramite l’[Intent-Driven Development](idd) (IDD) — ben oltre il codice software, come guida condivisa tra persona e IA attraverso intenti, decisioni e scenari di verifica. E ogni volta che manca una capacità, Veridion progetta e costruisce nuovi sistemi di IA arbitrariamente complessi — l’IA sviluppa l’IA.",
    "units": [
      {
        "name": "Sviluppo software",
        "text": "Presidia il software dal requisito all’esercizio: architettura, codice, test, review, pipeline e la qualità che c’è dietro."
      },
      {
        "name": "Elettronica & firmware",
        "text": "Presidia il lato hardware: circuiti, firmware e la scelta di ogni componente."
      },
      {
        "name": "Quantum computing & IA quantistica",
        "text": "Presidia la ricerca su quantum computing e IA quantistica e trasforma i risultati solidi in prodotti."
      },
      {
        "name": "Vendite & marketing",
        "text": "Presidia il mercato: lo osserva, individua i clienti target, redige dossier, prepara testi e offerte. A concludere è una persona."
      },
      {
        "name": "Prodotti & gestione della piattaforma",
        "text": "Presidia prodotti ed esercizio: strategia, priorità, release, e in più monitoraggio, incidenti e capacità della piattaforma in funzione."
      },
      {
        "name": "Amministrazione & finanze",
        "text": "Presidia la parte commerciale: giustificativi, fatture, contratti, scadenze, preparati fino alla firma, che resta a voi."
      }
    ]
  },
  "trust": {
    "title": "Su che cosa potete contare",
    "cards": [
      {
        "title": "Human-in-the-Loop & IDD ben oltre il codice",
        "text": "L’Intent-Driven Development ([IDD](idd)) va ben oltre lo sviluppo software: è ciò che la persona nel loop fa insieme all’IA in ogni ambito aziendale. Persone e IA formulano insieme l’intento (Intent), stabiliscono decisioni vincolanti (Decisions) e definiscono scenari verificabili (Scenarios) prima che i collaboratori IA eseguano in cicli fissi e pianificabili con l’approvazione mirata dell’essere umano."
      },
      {
        "title": "Comunicazione ottimizzata dalla teoria dei giochi",
        "text": "Il project management e la comunicazione dei collaboratori IA sono ottimizzati dalla teoria dei giochi, dal singolo collaboratore IA all’intera business unit: accuratezza e obiezione motivata premiano; approvare senza esaminare, ripetersi e scaricare la responsabilità costano. Così si impone la comunicazione migliore."
      },
      {
        "title": "Spiegabile fino alla fonte",
        "text": "Explainable AI qui è principio di lavoro, non un’aggiunta: ogni risultato espone da che cosa è nato, i passaggi nella conoscenza aziendale, i dati, il percorso di calcolo. Ciò che non ha un riscontro non viene affermato."
      },
      {
        "title": "Impara da sé",
        "text": "Dopo ogni passaggio si leggono i propri indicatori e si adattano di conseguenza le proprie regole: ogni progetto in corso migliora l’insieme."
      }
    ]
  },
  "daily": {
    "title": "Che cosa viene già preso in carico oggi",
    "subtitle": "Ogni giorno, in tutta l’azienda.",
    "items": [
      {
        "title": "Sviluppo",
        "text": "Codice, test e documentazione da decisioni registrate. Modernizzazione del software storico con prova golden master e back-to-back."
      },
      {
        "title": "Elettronica & firmware",
        "text": "Analizzare i datasheet, simulare i circuiti come gemelli digitali, sviluppare il firmware e valutare le alternative dei componenti prima che qualcosa venga costruito, vicino all’hardware fino al sensore."
      },
      {
        "title": "Ricerca quantistica",
        "text": "Leggere lo stato dell’arte, costruire e valutare esperimenti riproducibili contro basi di confronto classiche, ogni risultato registrato in modo tracciabile."
      },
      {
        "title": "Analisi dei dati",
        "text": "SQL Server, MariaDB, MySQL e Oracle: piano di analisi tipizzato, query rigorosamente in sola lettura, statistiche calcolate dall’ambiente di esecuzione, rapporti da un unico risultato versionato."
      },
      {
        "title": "Amministrazione & finanze",
        "text": "Contabilità, gestione finanziaria e la burocrazia di una società: leggere, classificare e archiviare i giustificativi; bozze di fatture e contratti comprese."
      },
      {
        "title": "Progetti & attività",
        "text": "Da una trascrizione di riunione nascono, senza deviazioni, attività nel project management, e l’avanzamento rifluisce: la riunione successiva inizia dallo stato attuale."
      },
      {
        "title": "Conoscenza aziendale",
        "text": "Una base di conoscenza per i documenti e un database a grafo che collega attività, decisioni, persone e sistemi: contesto attraverso settimane e oltre i confini dei progetti."
      },
      {
        "title": "Ricerca su Internet",
        "text": "Ciò che la conoscenza aziendale non contiene viene ricercato: si cerca, si leggono le pagine migliori e alla fine resta un rapporto in cui ogni affermazione ha la sua fonte numerata."
      },
      {
        "title": "Voce & riunioni",
        "text": "L’intera azienda si può guidare in mobilità: le conversazioni parlate svolgono lo stesso lavoro della chat, anche in viaggio al telefono."
      },
      {
        "title": "Lavoro d’ufficio con RoBuddy",
        "text": "RoBuddy copre la postazione di lavoro: appuntamenti, e-mail, formazione e domande sulla protezione dei dati. Le unità coprono il resto dell’azienda."
      }
    ]
  },
  "operate": {
    "title": "Esercizio",
    "cards": [
      {
        "title": "On-premises o nel vostro cloud",
        "text": "In anticipo calcoliamo insieme quali processi convengono: return on investment e costi totali sono sul tavolo. L’esercizio corre sul vostro hardware o nel vostro cloud, senza che un documento lasci l’azienda."
      },
      {
        "title": "Da noi",
        "text": "La pAIoneer Labs GmbH è costruita così dalle fondamenta: su questa base girano i nostri progetti, la nostra conoscenza aziendale e la nostra amministrazione. L’organizzazione sviluppa da sé l’[assistente di trading](finance) della nostra piattaforma ed è l’IA nella sua chat."
      }
    ]
  },
  "cta": {
    "title": "Richiesta",
    "subtitle": "Come software server nella vostra infrastruttura. Il prezzo lo comunichiamo su richiesta.",
    "button": "Invia richiesta",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
